module.exports = __webpack_public_path__ + "assets/img/img-map-okinawa-sp.715261c3.svg";